/* TERSA · buscador de ciudad para el formulario de pedido (EasySell).
   Cambia la lista nativa de cientos de municipios por una hoja con buscador y ciudades principales primero.
   Si algo falla, el selector nativo sigue funcionando igual que antes. */
(function () {
  'use strict';
  if (window.__ciudadBuscador) return;
  window.__ciudadBuscador = true;

  var SEL = '#es-city';
  var MIN_OPCIONES = 12;
  /* Ciudades principales por departamento (nombre normalizado, sin tildes). Solo coincidencia exacta del nombre,
     para no confundir una ciudad con veredas o corregimientos que empiezan igual. */
  var PRINCIPALES = {
    'antioquia': ['medellin', 'envigado', 'itagui', 'sabaneta', 'bello', 'la estrella', 'rionegro', 'caldas', 'copacabana', 'girardota', 'apartado', 'turbo', 'marinilla', 'el retiro', 'la ceja', 'guarne', 'carmen de viboral'],
    'cundinamarca': ['bogota', 'soacha', 'chia', 'zipaquira', 'facatativa', 'fusagasuga', 'girardot', 'cajica', 'mosquera', 'funza', 'madrid', 'sopo', 'la calera', 'tocancipa', 'cota'],
    'valle del cauca': ['cali', 'palmira', 'buenaventura', 'tulua', 'cartago', 'jamundi', 'yumbo', 'candelaria', 'guadalajara de buga', 'buga', 'florida', 'pradera'],
    'atlantico': ['barranquilla', 'soledad', 'malambo', 'puerto colombia', 'sabanalarga', 'galapa', 'baranoa'],
    'bolivar': ['cartagena', 'magangue', 'turbaco', 'arjona', 'el carmen de bolivar', 'mompos'],
    'santander': ['bucaramanga', 'floridablanca', 'giron', 'piedecuesta', 'barrancabermeja', 'san gil', 'socorro', 'barbosa'],
    'norte de santander': ['cucuta', 'villa del rosario', 'los patios', 'ocana', 'pamplona', 'el zulia'],
    'risaralda': ['pereira', 'dosquebradas', 'la virginia', 'santa rosa de cabal'],
    'caldas': ['manizales', 'villamaria', 'la dorada', 'chinchina', 'riosucio'],
    'quindio': ['armenia', 'calarca', 'montenegro', 'la tebaida', 'circasia', 'quimbaya'],
    'tolima': ['ibague', 'espinal', 'melgar', 'honda', 'chaparral', 'mariquita', 'libano'],
    'huila': ['neiva', 'pitalito', 'garzon', 'la plata'],
    'meta': ['villavicencio', 'acacias', 'granada', 'puerto lopez', 'restrepo'],
    'boyaca': ['tunja', 'duitama', 'sogamoso', 'chiquinquira', 'paipa', 'moniquira'],
    'magdalena': ['santa marta', 'cienaga', 'fundacion', 'el banco', 'plato'],
    'cesar': ['valledupar', 'aguachica', 'codazzi', 'bosconia', 'curumani'],
    'cordoba': ['monteria', 'cerete', 'sahagun', 'lorica', 'planeta rica', 'montelibano'],
    'sucre': ['sincelejo', 'corozal', 'sampues', 'san marcos'],
    'cauca': ['popayan', 'santander de quilichao', 'puerto tejada', 'patia'],
    'narino': ['pasto', 'ipiales', 'tumaco', 'tuquerres'],
    'la guajira': ['riohacha', 'maicao', 'uribia', 'fonseca', 'san juan del cesar'],
    'casanare': ['yopal', 'aguazul', 'villanueva', 'paz de ariporo'],
    'caqueta': ['florencia'],
    'arauca': ['arauca', 'saravena', 'arauquita'],
    'putumayo': ['mocoa', 'puerto asis', 'orito']
  };

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[.,]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function listaPrincipales() {
    try {
      var p = document.querySelector('#es-province');
      var nombre = norm(p && p.selectedOptions && p.selectedOptions[0] ? p.selectedOptions[0].text : '');
      return PRINCIPALES[nombre] || [];
    } catch (e) { return []; }
  }
  function rangoPrincipal(nombre, lista) {
    var n = norm(nombre);
    for (var i = 0; i < lista.length; i++) {
      var p = lista[i];
      if (n === p || n.indexOf(p + ' distrito') === 0 || (p === 'cartagena' && n.indexOf('cartagena de indias') === 0) || (p === 'bogota' && n === 'bogota d c')) return i;
    }
    return -1;
  }

  var css = '#vc-ov{position:fixed;inset:0;z-index:2147483647;background:#fff;display:flex;flex-direction:column;font-family:inherit;color:#161616}' +
    '#vc-ov *{box-sizing:border-box}' +
    '#vc-ov .vc-head{display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #e7e3da;font-size:17px}' +
    '#vc-ov .vc-x{appearance:none;-webkit-appearance:none;border:0;background:#f1eee7;color:#161616;width:38px;height:38px;border-radius:50%;font-size:18px;line-height:1;cursor:pointer}' +
    '#vc-ov .vc-busca{padding:12px 16px;border-bottom:1px solid #e7e3da}' +
    '#vc-ov .vc-busca input{width:100%;height:50px;border:2px solid #6B1B2E;border-radius:10px;padding:0 14px;font-size:16px;font-family:inherit;color:#161616;background:#fff;-webkit-appearance:none;appearance:none}' +
    '#vc-ov .vc-lista{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}' +
    '#vc-ov .vc-tit{position:sticky;top:0;background:#f7f4ee;color:#6b665c;font-size:12px;letter-spacing:.08em;text-transform:uppercase;padding:8px 16px;font-weight:700}' +
    '#vc-ov .vc-it{appearance:none;-webkit-appearance:none;display:flex;width:100%;align-items:center;justify-content:space-between;min-height:52px;padding:0 16px;border:0;border-bottom:1px solid #f0ede6;background:#fff;color:#161616;font-size:17px;font-family:inherit;text-align:left;cursor:pointer}' +
    '#vc-ov .vc-it:active{background:#efece4}' +
    '#vc-ov .vc-it.vc-sel{font-weight:700}' +
    '#vc-ov .vc-sel:after{content:"\\2713";color:#6B1B2E}' +
    '#vc-ov .vc-vacio{padding:28px 16px;color:#6b665c;font-size:15px;line-height:1.4}';

  var ov, lista, input, selActual, abierto = false, overflowPrev = '';

  function construir() {
    if (ov) return;
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    ov = document.createElement('div'); ov.id = 'vc-ov'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true');
    ov.style.display = 'none';
    ov.innerHTML = '<div class="vc-head"><strong>Elige tu ciudad</strong><button type="button" class="vc-x" aria-label="Cerrar">&#10005;</button></div>' +
      '<div class="vc-busca"><input type="search" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="search" placeholder="Escribe tu ciudad o municipio"></div>' +
      '<div class="vc-lista"></div>';
    document.body.appendChild(ov);
    lista = ov.querySelector('.vc-lista'); input = ov.querySelector('input');
    ov.querySelector('.vc-x').addEventListener('click', cerrar);
    input.addEventListener('input', pintar);
    lista.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.vc-it') : null;
      if (b) elegir(b.getAttribute('data-v'));
    });
    document.addEventListener('keydown', function (e) { if (abierto && e.key === 'Escape') cerrar(); });
  }

  function opciones() {
    var out = [], lista = listaPrincipales();
    for (var i = 0; i < selActual.options.length; i++) {
      var o = selActual.options[i];
      if (!o.value || /^selecciona/i.test(o.text)) continue;
      out.push({ v: o.value, t: o.text, n: norm(o.text), r: rangoPrincipal(o.text, lista) });
    }
    return out;
  }

  function item(o) {
    var b = document.createElement('button'); b.type = 'button';
    b.className = 'vc-it' + (o.v === selActual.value ? ' vc-sel' : '');
    b.setAttribute('data-v', o.v); b.textContent = o.t;
    return b;
  }
  function titulo(txt) { var d = document.createElement('div'); d.className = 'vc-tit'; d.textContent = txt; return d; }

  function pintar() {
    var q = norm(input.value), todas = opciones(), frag = document.createDocumentFragment(), i;
    lista.innerHTML = '';
    if (!q) {
      var pr = todas.filter(function (o) { return o.r >= 0; }).sort(function (a, b) { return a.r - b.r; });
      if (pr.length) { frag.appendChild(titulo('Ciudades principales')); pr.forEach(function (o) { frag.appendChild(item(o)); }); frag.appendChild(titulo('Todas (A a Z)')); }
      todas.filter(function (o) { return o.r < 0; }).forEach(function (o) { frag.appendChild(item(o)); });
    } else {
      var ini = todas.filter(function (o) { return o.n.indexOf(q) === 0; });
      var con = todas.filter(function (o) { return o.n.indexOf(q) > 0; });
      var res = ini.concat(con).slice(0, 80);
      if (!res.length) { var v = document.createElement('div'); v.className = 'vc-vacio'; v.textContent = 'No encontramos esa ciudad en este departamento. Revisa que el departamento esté bien o escribe otra parte del nombre.'; frag.appendChild(v); }
      for (i = 0; i < res.length; i++) frag.appendChild(item(res[i]));
    }
    lista.appendChild(frag); lista.scrollTop = 0;
  }

  function abrir(sel) {
    if (abierto || !sel || sel.options.length < MIN_OPCIONES) return false;
    try {
      selActual = sel; construir();
      input.value = ''; pintar();
      overflowPrev = document.body.style.overflow; document.body.style.overflow = 'hidden';
      ov.style.display = 'flex'; abierto = true;
      var sel1 = lista.querySelector('.vc-sel'); if (sel1) sel1.scrollIntoView({ block: 'center' });
      input.focus();
      return true;
    } catch (e) { abierto = false; if (ov) ov.style.display = 'none'; return false; }
  }

  function cerrar() {
    if (!abierto) return;
    ov.style.display = 'none'; document.body.style.overflow = overflowPrev; abierto = false;
    try { selActual.blur(); } catch (e) { }
  }

  function elegir(valor) {
    var setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value');
    if (setter && setter.set) setter.set.call(selActual, valor); else selActual.value = valor;
    selActual.dispatchEvent(new Event('input', { bubbles: true }));
    selActual.dispatchEvent(new Event('change', { bubbles: true }));
    cerrar();
  }

  function esCiudad(t) { return t && t.closest ? t.closest(SEL) : null; }
  var toque = null;
  document.addEventListener('mousedown', function (e) { var s = esCiudad(e.target); if (s && abrir(s)) e.preventDefault(); }, true);
  document.addEventListener('touchstart', function (e) { var t = e.touches && e.touches[0]; toque = esCiudad(e.target) && t ? { x: t.clientX, y: t.clientY } : null; }, { capture: true, passive: true });
  document.addEventListener('touchend', function (e) {
    var s = esCiudad(e.target), t = e.changedTouches && e.changedTouches[0];
    if (!s || !toque || !t) return;
    if (Math.abs(t.clientX - toque.x) < 10 && Math.abs(t.clientY - toque.y) < 10 && abrir(s)) { if (e.cancelable) e.preventDefault(); }
    toque = null;
  }, { capture: true, passive: false });
  document.addEventListener('click', function (e) { var s = esCiudad(e.target); if (s && abrir(s)) e.preventDefault(); }, true);
  document.addEventListener('keydown', function (e) {
    var s = esCiudad(e.target);
    if (s && (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown' || e.key === 'ArrowUp') && abrir(s)) e.preventDefault();
  }, true);
})();
